import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beCreateAppointment';
const AT = actionType(ATAG);

const beCreateAppointment = withOptions(({ salonId, data, deposit }) =>
  endpoint(H.post, 'salon/:salonId/appointment/', {
    AT,
    name: ATAG,
    params: { salonId, deposit },
    data,
  }),
);

beCreateAppointment.AT = AT;
beCreateAppointment.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beCreateAppointment;
